module.exports = new __parcel__URL__("trojan-avocado.4eaf3db6.png").toString();